import {
  IAM_DATASOURCE_ID,
  LAKE_FORMATION_DATASOURCE_ID,
  REDSHIFT_DATASOURCE_ID,
  S3_TABLE_DATASOURCE_ID,
} from 'src/commons/constants';
import {
  generateHcGlueCatalogId,
  generateHcGlueDatabaseId,
  generateHcRedshiftSchemaId,
} from 'src/components/utils/arnUtil';

export const getDataSource = (resourceDetails) => {
  //This helper is used as default value if we can't get the datasource from the item itself.
  if (resourceDetails.ClusterIdentifier != null || resourceDetails.RedshiftWorkgroupName != null) {
    return REDSHIFT_DATASOURCE_ID;
  } else if (resourceDetails.BucketName != null) {
    return S3_TABLE_DATASOURCE_ID;
  } else if (resourceDetails.DataAccessRole == null) {
    return IAM_DATASOURCE_ID;
  } else {
    return LAKE_FORMATION_DATASOURCE_ID;
  }
};

export const generateCatalogId = (catalog) => {
  const dataSource = catalog.DataSourceId ? catalog.DataSourceId : getDataSource(catalog);
  return generateHcGlueCatalogId({
    dataSource,
    catalogId: catalog.CatalogId,
    clusterId: catalog.ClusterIdentifier,
    redshiftWorkgroupName: catalog.RedshiftWorkgroupName,
    bucketName: catalog.BucketName,
    region: catalog.Region,
  });
};

export const generateDatabaseId = (database) => {
  const dataSource = database.DataSourceId ? database.DataSourceId : getDataSource(database);
  return generateHcGlueDatabaseId({
    dataSource,
    catalogId: database.CatalogId,
    clusterId: database.ClusterIdentifier,
    redshiftWorkgroupName: database.RedshiftWorkgroupName,
    bucketName: database.BucketName,
    databaseName: database.DatabaseName,
    region: database.Region,
  });
};

export const generateDatasetId = (dataset) => {
  return dataset.Id;
};

export const generateSchemaId = (schema) => {
  const dataSource = schema.DataSourceId ? schema.DataSourceId : REDSHIFT_DATASOURCE_ID;
  return generateHcRedshiftSchemaId({
    dataSource,
    catalogId: schema.CatalogId,
    clusterId: schema.ClusterIdentifier,
    redshiftWorkgroupName: schema.RedshiftWorkgroupName,
    databaseName: schema.DatabaseName,
    schemaName: schema.Schema,
    region: schema.Region,
  });
};

export const getDatasetUpperLevelResourceId = (dataset) => {
  let dataSourceId = dataset.IdInfo.DataSourceId;
  if (dataSourceId == LAKE_FORMATION_DATASOURCE_ID) {
    return generateHcGlueDatabaseId({
      dataSource: dataSourceId,
      catalogId: dataset.IdInfo.CatalogId,
      clusterId: dataset.IdInfo.ClusterIdentifier,
      redshiftWorkgroupName: dataset.IdInfo.RedshiftWorkgroupName,
      bucketName: dataset.IdInfo.BucketName,
      databaseName: dataset.IdInfo.DatabaseName,
      region: dataset.IdInfo.Region,
    });
  } else {
    return generateHcRedshiftSchemaId({
      dataSource: dataSourceId,
      catalogId: dataset.IdInfo.CatalogId,
      clusterId: dataset.IdInfo.ClusterIdentifier,
      redshiftWorkgroupName: dataset.IdInfo.RedshiftWorkgroupName,
      databaseName: dataset.IdInfo.DatabaseName,
      schemaName: dataset.IdInfo.SchemaName,
      region: dataset.IdInfo.Region,
    });
  }
};
